import { me } from '../helpers';
import moment from 'moment';

const getDemoData = () => {
	return {
		"@context":"/api/contexts/Live",
		"@id":"/api/lives/demo",
		"@type":"Live",
		"actions":[
			{
				"@id":"/api/actions/650",
				"@type":"Action",
				"data":{
					"option":"now",
					"actionName":`Début de la rencontre (${moment().subtract(86, 'minute').format('HH:mm')})`,
					"label":"debut",
					"hour":"15:00",
					"startAt": moment().subtract(86, 'minute').format('HH:mm:ss'),
					"halftime":"45"
				},
				"type":"/api/action_types/1",
				"live":"/api/lives/240",
				"teamId":null,
				"teamName":null,
				"minute":null
			},
			{
				"@id":"/api/actions/651",
				"@type":"Action",
				"data":{
					"label":"coup-de-pied-arrete",
					"tir":"coup de pied arrêté",
					"actionName":"Coup de pied arrêté de PARIS SAINT-GERMAIN",
					"description":"Coup franc",
					"team":"500247",
					"teamName":"PARIS SAINT-GERMAIN",
					"score":{
						"away":1,
						"home":1
					},
					"player":null,
					"inputs":{
						"value":"coup franc",
						"array":[
							{
								"value":"coup franc",
								"label":"Coup franc"
							},
							{
								"value":"corner",
								"label":"Corner"
							}
						]
					}
				},
				"type":"/api/action_types/14",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":18
			},
			{
				"@id":"/api/actions/652",
				"@type":"Action",
				"data":{
					"label":"tir",
					"tir":"tir",
					"actionName":"Tir de PARIS SAINT-GERMAIN",
					"description":"Tir non cadré",
					"team":"500247",
					"teamName":"PARIS SAINT-GERMAIN",
					"score":{
						"away":1,
						"home":1
					},
					"player":null,
					"inputs":{
						"value":"non cadré",
						"array":[
							{
								"value":"cadré",
								"label":"Cadré"
							},
							{
								"value":"non cadré",
								"label":"Non cadré"
							},
							{
								"value":"sur le poteau",
								"label":"Sur le poteau"
							},
							{
								"value":"sur la barre",
								"label":"Sur la barre"
							}
						]
					}
				},
				"type":"/api/action_types/11",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":23
			},
			{
				"@id":"/api/actions/653",
				"@type":"Action",
				"data":{
					"label":"carton-jaune",
					"actionName":"Carton jaune pour LOSC",
					"team":"500054",
					"teamName":"LOSC",
					"color":"yellow",
					"inputs":{
						"value":"carton jaune",
						"array":[
							{
								"value":"carton jaune",
								"label":"Carton jaune"
							},
							{
								"value":"carton rouge",
								"label":"Carton rouge"
							},
							{
								"value":"carton blanc",
								"label":"Carton blanc"
							}
						]
					}
				},
				"type":"/api/action_types/10",
				"live":"/api/lives/240",
				"teamId":500054,
				"teamName":"LOSC",
				"minute":26
			},
			{
				"@id":"/api/actions/654",
				"@type":"Action",
				"data":{
					"label":"coup-de-pied-arrete",
					"tir":"coup de pied arrêté",
					"actionName":"Coup de pied arrêté de PARIS SAINT-GERMAIN",
					"description":"Coup franc",
					"team":"500247",
					"teamName":"PARIS SAINT-GERMAIN",
					"score":{
						"away":1,
						"home":1
					},
					"player":null,
					"inputs":{
						"value":"coup franc",
						"array":[
							{
								"value":"coup franc",
								"label":"Coup franc"
							},
							{
								"value":"corner",
								"label":"Corner"
							}
						]
					}
				},
				"type":"/api/action_types/14",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":26
			},
			{
				"@id":"/api/actions/655",
				"@type":"Action",
				"data":{
					"label":"but",
					"actionName":"BUT ! de PARIS SAINT-GERMAIN",
					"description":"",
					"team":"500247",
					"teamName":"PARIS SAINT-GERMAIN",
					"category":"home",
					"player":null,
					"inputs":{
						"value":"",
						"array":[
							{
								"value":"face à face avec le gardien",
								"label":"Face à face avec le gardien"
							},
							{
								"value":"frappe dans la surface",
								"label":"Frappe dans la surface"
							},
							{
								"value":"frappe en dehors de la surface",
								"label":"Frappe en dehors de la surface"
							},
							{
								"value":"tête",
								"label":"Tête"
							},
							{
								"value":"reprise de volée",
								"label":"Reprise de volée"
							},
							{
								"value":"coup franc direct",
								"label":"Coup franc direct"
							},
							{
								"value":"contre son camp",
								"label":"Contre son camp"
							},
							{
								"value":"talonnade",
								"label":"Talonnade"
							}
						]
					}
				},
				"type":"/api/action_types/8",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":27
			},
			{
			"@id":"/api/actions/656",
			"@type":"Action",
			"data":{
				"label":"coup-de-pied-arrete",
				"tir":"coup de pied arrêté",
				"actionName":"Coup de pied arrêté de LOSC",
				"description":"Corner",
				"team":"500054",
				"teamName":"LOSC",
				"score":{
					"away":null,
					"home":1
				},
				"player":null,
				"inputs":{
					"value":"corner",
					"array":[
						{
							"value":"coup franc",
							"label":"Coup franc"
						},
						{
							"value":"corner",
							"label":"Corner"
						}
					]
				}
			},
			"type":"/api/action_types/14",
			"live":"/api/lives/240",
			"teamId":500054,
			"teamName":"LOSC",
			"minute":32
			},
			{
				"@id":"/api/actions/657",
				"@type":"Action",
				"data":{
					"label":"but",
					"actionName":"BUT ! de LOSC",
					"description":"Tête",
					"team":"500054",
					"teamName":"LOSC",
					"category":"away",
					"player":null,
					"inputs":{
						"value":"tête",
						"array":[
							{
								"value":"face à face avec le gardien",
								"label":"Face à face avec le gardien"
							},
							{
								"value":"frappe dans la surface",
								"label":"Frappe dans la surface"
							},
							{
								"value":"frappe en dehors de la surface",
								"label":"Frappe en dehors de la surface"
							},
							{
								"value":"tête",
								"label":"Tête"
							},
							{
								"value":"reprise de volée",
								"label":"Reprise de volée"
							},
							{
								"value":"coup franc direct",
								"label":"Coup franc direct"
							},
							{
								"value":"contre son camp",
								"label":"Contre son camp"
							},
							{
								"value":"talonnade",
								"label":"Talonnade"
							}
						]
					}
				},
				"type":"/api/action_types/8",
				"live":"/api/lives/240",
				"teamId":500054,
				"teamName":"LOSC",
				"minute":33
			},
			{
				"@id":"/api/actions/658",
				"@type":"Action",
				"data":{
					"label":"tir",
					"tir":"tir",
					"actionName":"Tir de LOSC",
					"description":"Tir sur le poteau",
					"team":"500054",
					"teamName":"LOSC",
					"score":{
						"away":1,
						"home":1
					},
					"player":null,
					"inputs":{
						"value":"sur le poteau",
						"array":[
							{
								"value":"cadré",
								"label":"Cadré"
							},
							{
								"value":"non cadré",
								"label":"Non cadré"
							},
							{
								"value":"sur le poteau",
								"label":"Sur le poteau"
							},
							{
								"value":"sur la barre",
								"label":"Sur la barre"
							}
						]
					}
				},
				"type":"/api/action_types/11",
				"live":"/api/lives/240",
				"teamId":500054,
				"teamName":"LOSC",
				"minute":41
			},
			{
				"@id":"/api/actions/659",
				"@type":"Action",
				"data":{
					"label":"carton-jaune",
					"actionName":"Carton jaune pour PARIS SAINT-GERMAIN",
					"team":"500247",
					"teamName":"PARIS SAINT-GERMAIN",
					"color":"yellow",
					"inputs":{
						"value":"carton jaune",
						"array":[
							{
								"value":"carton jaune",
								"label":"Carton jaune"
							},
							{
								"value":"carton rouge",
								"label":"Carton rouge"
							},
							{
								"value":"carton blanc",
								"label":"Carton blanc"
							}
						]
					}
				},
				"type":"/api/action_types/10",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":44
			},
			{
				"@id":"/api/actions/660",
				"@type":"Action",
				"data":{
					"label":"coup-de-pied-arrete",
					"tir":"coup de pied arrêté",
					"actionName":"Coup de pied arrêté de LOSC",
					"description":"Coup franc",
					"team":"500054",
					"teamName":"LOSC",
					"score":{
						"away":1,
						"home":1
					},
					"player":null,
					"inputs":{
						"value":"coup franc",
						"array":[
							{
								"value":"coup franc",
								"label":"Coup franc"
							},
							{
								"value":"corner",
								"label":"Corner"
							}
						]
					}
				},
				"type":"/api/action_types/14",
				"live":"/api/lives/240",
				"teamId":500054,
				"teamName":"LOSC",
				"minute":44
			},
			{
			"@id":"/api/actions/661",
			"@type":"Action",
			"data":{
				"label":"but",
				"actionName":"BUT ! de LOSC",
				"description":"Coup franc direct",
				"team":"500054",
				"teamName":"LOSC",
				"category":"away",
				"player":null,
				"inputs":{
					"value":"coup franc direct",
					"array":[
						{
							"value":"face à face avec le gardien",
							"label":"Face à face avec le gardien"
						},
						{
							"value":"frappe dans la surface",
							"label":"Frappe dans la surface"
						},
						{
							"value":"frappe en dehors de la surface",
							"label":"Frappe en dehors de la surface"
						},
						{
							"value":"tête",
							"label":"Tête"
						},
						{
							"value":"reprise de volée",
							"label":"Reprise de volée"
						},
						{
							"value":"coup franc direct",
							"label":"Coup franc direct"
						},
						{
							"value":"contre son camp",
							"label":"Contre son camp"
						},
						{
							"value":"talonnade",
							"label":"Talonnade"
						}
					]
				}
			},
			"type":"/api/action_types/8",
			"live":"/api/lives/240",
			"teamId":500054,
			"teamName":"LOSC",
			"minute":45
			},
			{
				"@id":"/api/actions/662",
				"@type":"Action",
				"data":{
					"actionName":"Fin de la première période",
					"label":"mi_temps"
				},
				"type":"/api/action_types/2",
				"live":"/api/lives/240",
				"teamId":null,
				"teamName":null,
				"minute":51
			},
			{
				"@id":"/api/actions/663",
				"@type":"Action",
				"data":{
					"actionName":"Début de la seconde période",
					"label":"reprise",
					"startAt": moment().subtract(41, 'minute').format('HH:mm:ss')
				},
				"type":"/api/action_types/3",
				"live":"/api/lives/240",
				"teamId":null,
				"teamName":null,
				"minute":45
			},
			{
				"@id":"/api/actions/664",
				"@type":"Action",
				"data":{
					"label":"tir",
					"tir":"tir",
					"actionName":"Tir de PARIS SAINT-GERMAIN",
					"description":"Tir sur la barre",
					"team":"500247",
					"teamName":"PARIS SAINT-GERMAIN",
					"score":{
						"away":2,
						"home":1
					},
					"player":null,
					"inputs":{
						"value":"sur la barre",
						"array":[
							{
								"value":"cadré",
								"label":"Cadré"
							},
							{
								"value":"non cadré",
								"label":"Non cadré"
							},
							{
								"value":"sur le poteau",
								"label":"Sur le poteau"
							},
							{
								"value":"sur la barre",
								"label":"Sur la barre"
							}
						]
					}
				},
				"type":"/api/action_types/11",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":54
			},
			{
				"@id":"/api/actions/665",
				"@type":"Action",
				"data":{
					"label":"tir",
					"tir":"tir",
					"actionName":"Tir de PARIS SAINT-GERMAIN",
					"description":"Tir non cadré",
					"team":"500247",
					"teamName":"PARIS SAINT-GERMAIN",
					"score":{
						"away":2,
						"home":1
					},
					"player":null,
					"inputs":{
						"value":"non cadré",
						"array":[
							{
								"value":"cadré",
								"label":"Cadré"
							},
							{
								"value":"non cadré",
								"label":"Non cadré"
							},
							{
								"value":"sur le poteau",
								"label":"Sur le poteau"
							},
							{
								"value":"sur la barre",
								"label":"Sur la barre"
							}
						]
					}
				},
				"type":"/api/action_types/11",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":58
			},
			{
				"@id":"/api/actions/666",
				"@type":"Action",
				"data":{
					"label":"coup-de-pied-arrete",
					"tir":"coup de pied arrêté",
					"actionName":"Coup de pied arrêté de PARIS SAINT-GERMAIN",
					"description":"Corner",
					"team":"500247",
					"teamName":"PARIS SAINT-GERMAIN",
					"score":{
						"away":2,
						"home":1
					},
					"player":null,
					"inputs":{
						"value":"corner",
						"array":[
							{
								"value":"coup franc",
								"label":"Coup franc"
							},
							{
								"value":"corner",
								"label":"Corner"
							}
						]
					}
				},
				"type":"/api/action_types/14",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":61
			},
			{
				"@id":"/api/actions/667",
				"@type":"Action",
				"data":{
					"label":"penalty_declaration",
					"actionName":"Penalty pour PARIS SAINT-GERMAIN",
					"description":"carton jaune pour LOSC LILLE ASSOCIATION",
					"sanction":"carton jaune",
					"teamSanctioned":"LOSC LILLE ASSOCIATION",
					"category":"home",
					"score":{
						"away":2,
						"home":1
					},
					"relatedAction":{
						"@id":"/api/actions/668",
						"@type":"Action",
						"data":{
							"label":"penalty_resultat-marque",
							"actionName":"BUT ! de PARIS SAINT-GERMAIN",
							"description":"",
							"success":true,
							"score":{
								"away":2,
								"home":2
							},
							"result":"marque",
							"player":null,
							"category":"home",
							"relatedAction":{
								"@id":"/api/actions/667",
								"@type":"Action",
								"data":{
									"label":"penalty_declaration",
									"actionName":"Penalty pour PARIS SAINT-GERMAIN",
									"description":"carton jaune pour LOSC LILLE ASSOCIATION",
									"sanction":"carton jaune",
									"teamSanctioned":"LOSC LILLE ASSOCIATION",
									"category":"home",
									"score":{
										"away":2,
										"home":1
									}
								},
								"type":{
									"@id":"/api/action_types/12",
									"@type":"ActionType",
									"name":"Déclaration de penalty",
									"slug":"penalty_declaration",
									"data":null
								},
								"live":"/api/lives/240",
								"teamId":500247,
								"teamName":"PARIS SAINT-GERMAIN",
								"minute":68
							}
						},
						"type":{
							"@id":"/api/action_types/13",
							"@type":"ActionType",
							"name":"Résultat de penalty",
							"slug":"penalty_resultat",
							"data":{
								"scalable":false,
								"inputs":[
									{
										"title":"Équipe qui a reçu le penalty",
										"step":1,
										"type":"radio",
										"name":"q1-1",
										"values":{
										"home":"Home",
										"away":"Home"
										},
										"default":null,
										"required":true
									},
									{
										"title":"Détails du penalty",
										"label":"Sanction pour l'équipe adverse",
										"step":1,
										"type":"select",
										"name":"q2-1",
										"values":[
											{
												"option-01":"Carton jaune"
											},
											{
												"option-02":"Carton rouge"
											},
											{
												"option-03":"Carton blanc"
											}
										],
										"default":null,
										"required":false
									},
									{
										"title":"Finalité du penalty",
										"label":"Finalité",
										"step":2,
										"type":"select",
										"name":"q3-1",
										"values":[
											{
												"option-01":"Marqué"
											},
											{
												"option-02":"Arrêté"
											},
											{
												"option-03":"Manqué"
											}
										],
										"default":null,
										"required":true
									},
									{
										"title":"Informations optionnelles",
										"label":"Tireur (n° maillot)",
										"step":2,
										"type":"number",
										"name":"q4-1",
										"values":{
											"min":1,
											"max":99
										},
										"default":null,
										"required":false
									}
								],
								"steps":{
									"2":"Patiente quelques instants le temps que le joueur tire son penalty pour renseigner ces informations."
								}
							}
						},
						"live":"/api/lives/240",
						"teamId":500247,
						"teamName":"PARIS SAINT-GERMAIN",
						"minute":68
					}
				},
				"type":"/api/action_types/12",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":68
			},
			{
				"@id":"/api/actions/668",
				"@type":"Action",
				"data":{
					"label":"penalty_resultat-marque",
					"actionName":"BUT ! de PARIS SAINT-GERMAIN",
					"description":"",
					"success":true,
					"score":{
						"away":2,
						"home":2
					},
					"result":"marque",
					"player":null,
					"category":"home",
					"relatedAction":{
						"@id":"/api/actions/667",
						"@type":"Action",
						"data":{
							"label":"penalty_declaration",
							"actionName":"Penalty pour PARIS SAINT-GERMAIN",
							"description":"carton jaune pour LOSC LILLE ASSOCIATION",
							"sanction":"carton jaune",
							"teamSanctioned":"LOSC LILLE ASSOCIATION",
							"category":"home",
							"score":{
								"away":2,
								"home":1
							}
						},
						"type":{
							"@id":"/api/action_types/12",
							"@type":"ActionType",
							"name":"Déclaration de penalty",
							"slug":"penalty_declaration",
							"data":null
						},
						"live":"/api/lives/240",
						"teamId":500247,
						"teamName":"PARIS SAINT-GERMAIN",
						"minute":68
					}
				},
				"type":"/api/action_types/13",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":68
			},
			{
				"@id":"/api/actions/669",
				"@type":"Action",
				"data":{
					"label":"tir",
					"tir":"tir",
					"actionName":"Tir de LOSC",
					"description":"Tir cadré",
					"team":"500054",
					"teamName":"LOSC",
					"score":{
						"away":2,
						"home":2
					},
					"player":null,
					"inputs":{
						"value":"cadré",
						"array":[
							{
								"value":"cadré",
								"label":"Cadré"
							},
							{
								"value":"non cadré",
								"label":"Non cadré"
							},
							{
								"value":"sur le poteau",
								"label":"Sur le poteau"
							},
							{
								"value":"sur la barre",
								"label":"Sur la barre"
							}
						]
					}
				},
				"type":"/api/action_types/11",
				"live":"/api/lives/240",
				"teamId":500054,
				"teamName":"LOSC",
				"minute":73
			},
			{
				"@id":"/api/actions/670",
				"@type":"Action",
				"data":{
					"label":"tir",
					"tir":"tir",
					"actionName":"Tir de LOSC",
					"description":"Tir sur la barre",
					"team":"500054",
					"teamName":"LOSC",
					"score":{
						"away":2,
						"home":2
					},
					"player":null,
					"inputs":{
						"value":"sur la barre",
						"array":[
							{
								"value":"cadré",
								"label":"Cadré"
							},
							{
								"value":"non cadré",
								"label":"Non cadré"
							},
							{
								"value":"sur le poteau",
								"label":"Sur le poteau"
							},
							{
								"value":"sur la barre",
								"label":"Sur la barre"
							}
						]
					}
				},
				"type":"/api/action_types/11",
				"live":"/api/lives/240",
				"teamId":500054,
				"teamName":"LOSC",
				"minute":79
			},
			{
				"@id":"/api/actions/671",
				"@type":"Action",
				"data":{
					"label":"carton-jaune",
					"actionName":"Carton jaune pour LOSC",
					"team":"500054",
					"teamName":"LOSC",
					"color":"yellow",
					"inputs":{
						"value":"carton jaune",
						"array":[
							{
								"value":"carton jaune",
								"label":"Carton jaune"
							},
							{
								"value":"carton rouge",
								"label":"Carton rouge"
							},
							{
								"value":"carton blanc",
								"label":"Carton blanc"
							}
						]
					}
				},
				"type":"/api/action_types/10",
				"live":"/api/lives/240",
				"teamId":500054,
				"teamName":"LOSC",
				"minute":80
			},
			{
				"@id":"/api/actions/672",
				"@type":"Action",
				"data":{
					"label":"but",
					"actionName":"BUT ! de PARIS SAINT-GERMAIN",
					"description":"Talonnade",
					"team":"500247",
					"teamName":"PARIS SAINT-GERMAIN",
					"category":"home",
					"player":null,
					"inputs":{
						"value":"talonnade",
						"array":[
							{
								"value":"face à face avec le gardien",
								"label":"Face à face avec le gardien"
							},
							{
								"value":"frappe dans la surface",
								"label":"Frappe dans la surface"
							},
							{
								"value":"frappe en dehors de la surface",
								"label":"Frappe en dehors de la surface"
							},
							{
								"value":"tête",
								"label":"Tête"
							},
							{
								"value":"reprise de volée",
								"label":"Reprise de volée"
							},
							{
								"value":"coup franc direct",
								"label":"Coup franc direct"
							},
							{
								"value":"contre son camp",
								"label":"Contre son camp"
							},
							{
								"value":"talonnade",
								"label":"Talonnade"
							}
						]
					}
				},
				"type":"/api/action_types/8",
				"live":"/api/lives/240",
				"teamId":500247,
				"teamName":"PARIS SAINT-GERMAIN",
				"minute":84
			},
			{
				"@id":"/api/actions/673",
				"@type":"Action",
				"data":{
					"label":"coup-de-pied-arrete",
					"tir":"coup de pied arrêté",
					"actionName":"Coup de pied arrêté de LOSC",
					"description":"Corner",
					"team":"500054",
					"teamName":"LOSC",
					"score":{
						"away":2,
						"home":3
					},
					"player":null,
					"inputs":{
						"value":"corner",
						"array":[
							{
								"value":"coup franc",
								"label":"Coup franc"
							},
							{
								"value":"corner",
								"label":"Corner"
							}
						]
					}
				},
				"type":"/api/action_types/14",
				"live":"/api/lives/240",
				"teamId":500054,
				"teamName":"LOSC",
				"minute":85
			},
			{
				"@id":"/api/actions/674",
				"@type":"Action",
				"data":{
					"label":"but",
					"actionName":"BUT ! de LOSC",
					"description":"Tête",
					"team":"500054",
					"teamName":"LOSC",
					"category":"away",
					"player":null,
					"inputs":{
						"value":"tête",
						"array":[
							{
								"value":"face à face avec le gardien",
								"label":"Face à face avec le gardien"
							},
							{
								"value":"frappe dans la surface",
								"label":"Frappe dans la surface"
							},
							{
								"value":"frappe en dehors de la surface",
								"label":"Frappe en dehors de la surface"
							},
							{
								"value":"tête",
								"label":"Tête"
							},
							{
								"value":"reprise de volée",
								"label":"Reprise de volée"
							},
							{
								"value":"coup franc direct",
								"label":"Coup franc direct"
							},
							{
								"value":"contre son camp",
								"label":"Contre son camp"
							},
							{
								"value":"talonnade",
								"label":"Talonnade"
							}
						]
					}
				},
				"type":"/api/action_types/8",
				"live":"/api/lives/240",
				"teamId":500054,
				"teamName":"LOSC",
				"minute":86
			}
		],
		"ended":false,
		"author":{
			"@id":`/api/users/${me().id}`,
			"@type":"User",
			"nickname":me().nickname,
			"firstname":me().firstname,
			"lastname":me().lastname
		},
		"matchId":"d21440716",
		"score":{
			"away":3,
			"home":3
		},
		"grades":[],
		"gradeValue":0,
		"subscribers":[{"@id":"/api/users/22"},{"@id":"/api/users/23"},{"@id":"/api/users/24"},{"@id":"/api/users/25"},{"@id":"/api/users/26"},{"@id":"/api/users/22"}],
		"deleted":false,
		"matchDate":"2019-11-18T15:00:00+01:00",
		"match":{
			"@context":"/api/contexts/Match",
			"@id":"/api/matches/d21440716",
			"@type":"Match",
			"maNo":"d21440716",
			"formattedDate": moment().format('dddd DD MMMM YYYY - HH:ss'),
			"phNo":"1",
			"phaseType":"AC",
			"gpNo":"1",
			"cpNo":"362730",
			"cpType":"CH",
			"competition":"LIGUE 1",
			"competitionLevel":"F",
			"season":"2019",
			"journee":{
				"pj_lib_tour":"Journée 14"
			},
			"group":"GROUPE 0",
			"date": moment().subtract(86, 'minute').format('YYYYMMDDHHmm'),
			"dateClass":{
				"date":"2019-11-23 21:00:00.000000",
				"timezone_type":3,
				"timezone":"Europe/Paris"
			},
			"lcCode":null,
			"homeTeam":"PARIS SAINT GERMAIN F.",
			"homeTeamEqName":"PARIS SAINT-GERMAIN",
			"homeTeamClCod":"500247",
			"homeTeamClNo":"364",
			"homeTeamEqNo":"7",
			"homeTeamEqCod":null,
			"awayTeam":"LOSC LILLE ASSOCIATION",
			"awayTeamEqName":"LOSC",
			"awayTeamClCod":"500054",
			"awayTeamClNo":"199",
			"awayTeamEqNo":"1",
			"awayTeamEqCod":null,
			"homeTeamGoals":"0",
			"awayTeamGoals":"0",
			"homeTeamRanking":{
				"eq_name":"PARIS SAINT-GERMAIN",
				"eq_name_abr":"PARIS SAINT-GERMAIN",
				"cl_cod":"500247",
				"rang":"1",
				"pts":"9",
				"jo":"4",
				"g":"3",
				"n":"0",
				"p":"1",
				"f":"0",
				"bp":"10",
				"bc":"2",
				"pe":"0",
				"dif":"8"
			},
			"awayTeamRanking":{
				"eq_name":"LOSC",
				"eq_name_abr":"LOSC",
				"cl_cod":"500054",
				"rang":"10",
				"pts":"6",
				"jo":"4",
				"g":"2",
				"n":"0",
				"p":"2",
				"f":"0",
				"bp":"5",
				"bc":"4",
				"pe":"0",
				"dif":"1"
			},
			"stadium":{
				"address":["75016 PARIS 16"],
				"name":"STADE DU PARC DES PRINCES",
				"long":"2.25171",
				"lat":"48.8392",
				"surface":""
			},
			"officials":[]
		}
	}
}

export default getDemoData;